<div class="transport-page">
  <div
    class="parallax-bg"
    [style.transform]="backgroundTransform"
    [style.background-image]="backgroundImageUrl"
    aria-hidden="true"
  ></div>

  <ng-content></ng-content>
</div>
